import React from 'react'
import classes from 'components/Shared/Table/SortPriorityBadge/SortPriorityBadge.module.css'

export default ({ priority }) => (
  <div className={'my-auto px-1 ' + classes.badge}>
    {priority}
  </div>
)
